import React from 'react';
import { Button, Tooltip } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { MoneyKey } from '../../store/slices/dashboardPrivacySlice';
import { useMoneyPrivacy } from '../../hooks/useMoneyPrivacy';

interface MoneyEyeProps {
  /** Omitido, es el interruptor general (tapa o destapa todo de un toque). */
  moneyKey?: MoneyKey;
  size?: 'small' | 'middle' | 'large';
  style?: React.CSSProperties;
}

/**
 * Ojito para tapar o destapar cifras del dashboard. Sin `moneyKey` actúa como
 * el general, que es el gesto que de verdad importa: cuando se acerca alguien
 * no da tiempo de buscar tres ojitos.
 */
const MoneyEye: React.FC<MoneyEyeProps> = ({ moneyKey, size = 'small', style }) => {
  const { isHidden, allHidden, toggle, toggleAll } = useMoneyPrivacy();

  const hidden = moneyKey ? isHidden(moneyKey) : allHidden;
  const label = moneyKey
    ? (hidden ? 'Mostrar importe' : 'Ocultar importe')
    : (hidden ? 'Mostrar los importes' : 'Ocultar los importes');

  return (
    <Tooltip title={label}>
      <Button
        type="text"
        size={size}
        aria-label={label}
        aria-pressed={hidden}
        icon={hidden ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        onClick={() => (moneyKey ? toggle(moneyKey) : toggleAll())}
        style={{ color: 'var(--text-secondary)', ...style }}
      />
    </Tooltip>
  );
};

export default MoneyEye;
